/* eslint-disable no-useless-catch */
import { ENV } from "../utils";

export class Answer {
  baseApi = ENV.BASE_API;

  async getAnswers(accessToken, idPost) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.ANSWER}/${idPost}`;
      const params = {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async createAnswer(accessToken, data) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.ANSWER}`;
      const params = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(data),
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 201) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async updateAnswer(accessToken, idAnswer, data) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.ANSWER}/${idAnswer}`;
      const params = {
        method: "PATCH",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(data),
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async deleteAnswer(accessToken, idAnswer) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.ANSWER}/${idAnswer}`;
      const params = {
        method: "DELETE",
        headers: {
          Authorization: `Bearer ${accessToken}`,
        },
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async getAnswer(path) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.ANSWER}/${path}`;
      const response = await fetch(url);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }

  async toggleReaction(accessToken, idAnswer, type) {
    try {
      const url = `${this.baseApi}/${ENV.API_ROUTES.ANSWER}/react/${idAnswer}`;
      const params = {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify({ type }),
      };
      const response = await fetch(url, params);
      const result = await response.json();
      if (response.status !== 200) throw result;
      return result;
    } catch (error) {
      throw error;
    }
  }
}
